import { Baby, Briefcase, Smiley, User, UserCircle } from "@phosphor-icons/react";

export const GUEST_TYPES = [
  { id: "adult", label: "Adult", sub: "18+ years", icon: User, tone: "bg-primary" },
  { id: "teen", label: "Teen", sub: "13–17 years", icon: UserCircle, tone: "bg-[#8C6A23]" },
  { id: "child", label: "Child", sub: "4–12 years", icon: Smiley, tone: "bg-[#2D593F]" },
  { id: "baby", label: "Baby", sub: "0–3 years", icon: Baby, tone: "bg-[#8C2A36]" },
  { id: "vendor", label: "Vendor", sub: "Suppliers & crew", icon: Briefcase, tone: "bg-[#6E6A63]" },
];

export const DIETARY_OPTIONS = [
  { id: "none", label: "None", sub: "No requirements" },
  { id: "vegetarian", label: "Vegetarian", sub: "No meat or seafood" },
  { id: "vegan", label: "Vegan", sub: "No animal products" },
  { id: "gluten_free", label: "Gluten Free", sub: "Coeliac & gluten intolerance" },
  { id: "dairy_free", label: "Dairy Free", sub: "Lactose intolerance" },
  { id: "nut_allergy", label: "Nut Allergy", sub: "Tree nuts & peanuts" },
  { id: "halal", label: "Halal", sub: "Halal-prepared meals" },
  { id: "other", label: "Other", sub: "Anything else" },
];

export const TYPE_LABELS = Object.fromEntries(GUEST_TYPES.map((t) => [t.id, t.label]));
export const DIETARY_LABELS = Object.fromEntries(DIETARY_OPTIONS.map((d) => [d.id, d.label]));

/** Breakdown keys used by the guest-numbers module, mapped from guest types. */
export const BREAKDOWN_KEYS = [
  { id: "adults", type: "adult", label: "Adults", sub: "18+ years" },
  { id: "teens", type: "teen", label: "Teens", sub: "13–17 years" },
  { id: "children", type: "child", label: "Children", sub: "4–12 years" },
  { id: "babies", type: "baby", label: "Babies", sub: "0–3 years" },
];

export const DIETARY_TALLY_KEYS = DIETARY_OPTIONS.filter(
  (d) => d.id !== "none" && d.id !== "other",
);

export function guestType(guest) {
  return guest.type || (guest.is_child ? "child" : "adult");
}

export function deriveBreakdown(guests) {
  const counts = { adults: 0, teens: 0, children: 0, babies: 0 };
  guests.forEach((guest) => {
    const entry = BREAKDOWN_KEYS.find((b) => b.type === guestType(guest));
    if (entry) {
      counts[entry.id] += 1;
    }
  });
  return counts;
}

export function deriveDietary(guests) {
  const counts = {};
  DIETARY_TALLY_KEYS.forEach((d) => {
    counts[d.id] = 0;
  });
  guests.forEach((guest) => {
    if (counts[guest.dietary] !== undefined) {
      counts[guest.dietary] += 1;
    }
  });
  return counts;
}

export function initials(name) {
  return String(name)
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((part) => part[0]?.toUpperCase() || "")
    .join("");
}

export function typeTone(type) {
  return GUEST_TYPES.find((t) => t.id === type)?.tone || "bg-muted";
}

export function dietaryLabel(guest) {
  if (!guest.dietary || guest.dietary === "none") {
    return "";
  }
  if (guest.dietary === "other") {
    return guest.dietary_notes || "Other";
  }
  return DIETARY_LABELS[guest.dietary] || guest.dietary;
}
